import React from 'react';

const SigGta = ({ selectedGtaMap, setSelectedGtaMap }) => {
    return (
        <div className='container'>
            <div className='row justify-content-center'>
                <div className='col-md-auto m-1 cursor-pointer' onClick={() => setSelectedGtaMap('atlas')}>
                    <h2>Atlas</h2>
                    <img
                        src='maps/atlas/0/0/0.jpg'
                        alt='Atlas'
                        className={`img-thumbnail rounded mx-auto d-block ${selectedGtaMap === 'atlas' ? 'mapSelected' : ''}`}
                    />
                </div>
                <div className='col-md-auto m-1 cursor-pointer' onClick={() => setSelectedGtaMap('road')}>
                    <h2>Road</h2>
                    <img
                        src='maps/road/0/0/0.png'
                        alt='Road'
                        className={`img-thumbnail rounded mx-auto d-block ${selectedGtaMap === 'road' ? 'mapSelected' : ''}`}
                    />
                </div>
                <div className='col-md-auto m-1 cursor-pointer' onClick={() => setSelectedGtaMap('satellite')}>
                    <h2>Satellite</h2>
                    <img
                        src='maps/satellite/0/0/0.jpg'
                        alt='Satellite'
                        className={`img-thumbnail rounded mx-auto d-block ${selectedGtaMap === 'satellite' ? 'mapSelected' : ''}`}
                    />
                </div>
            </div>
        </div>
    );
};

export default SigGta;
